export default __webpack_public_path__ + "static/media/broccolini-and-potato-salad-with-blackberries.35000c31.png";